import { render } from "./OppDetailsHeader.vue?vue&type=template&id=218fa1d3"
import script from "./OppDetailsHeader.vue?vue&type=script&lang=js"
export * from "./OppDetailsHeader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__